import React from 'react';
import classNames from 'classnames';

// import './TextInput.css';
import styles from './TextInput.css';

interface TextInputProps {
  className?: string;
  placeholder?: string;
  value?: string;
  onChange?: (fieldName: string, value: string) => void;
  paddingTop?: string;
  paddingLeft?: string;
  height?: string;
  width?: string;
  // inputProps: {id, name}
  id?: string;
  name?: string;
  error?: string;
}

export default class TextInput extends React.Component<TextInputProps> {
  private readonly changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const { value } = event.target;
    const fieldName = event.target.name || event.target.id;
    const value = event.target.value;

    const { onChange } = this.props;
    if (onChange !== undefined) {
      onChange(fieldName, value);
    }
  };

  public render() {
    const {
      className,
      placeholder,
      value,
      paddingTop,
      paddingLeft,
      height,
      width,
      id,
      name,
      error,
    } = this.props;

    return (
      <div className={classNames(styles.root, className)} style={{ width }}>
        <input
          className={classNames(styles.text_input, { [styles.error_input]: error })}
          style={{ paddingTop, paddingLeft, height, width: '100%' }}
          value={value}
          onChange={this.changeHandler}
          placeholder={placeholder}
          type={'text'}
          {...{ id, name }}
        />
        {error && <p className={styles.error_msg}>{error}</p>}
      </div>
    );
  }
}
